import { DataSourceFactory } from "app/components/data/DataSource/DataSourceFactory";

interface IMockData {
  name: string
  y: number
  color: string
}

const PrivateFoundationsDataSources = DataSourceFactory.create<IMockData>({
  data: [{
    name: 'Cash',
    y: 7,
    color: '#041D37'
  }, {
    name: 'Bonds',
    y: 10,
    color: '#133253'
  }, {
    name: 'Alternative Investments',
    y: 18,
    color: '#4A6B8A'
  }, {
    name: 'Stocks',
    y: 55,
    color: '#738CA6'
  }]
})

export {
  PrivateFoundationsDataSources
}


// WEBPACK FOOTER //
// ./src/app/containers/PrivateFoundations/DataSources.ts